import { useCallback } from 'react'
import { usePostHog } from 'posthog-js/react'

import { EventName, EventPayload } from '@/utils/eventDefinitions'

/**
 * Type-safe PostHog analytics hook that mirrors the Segment API
 * Provides compile-time type checking for event names and payloads
 */
export const useAnalytics = () => {
  const posthog = usePostHog()
  const isLoaded = posthog?.__loaded ?? false

  const trackEvent = useCallback(
    <T extends EventName>(event: T, params: EventPayload<T>) => {
      posthog?.capture(event, params)
    },
    [posthog],
  )

  return {
    trackEvent: isLoaded ? trackEvent : undefined,
    identify: isLoaded ? posthog.identify.bind(posthog) : undefined,
    group: isLoaded ? posthog.group.bind(posthog) : undefined,
    alias: isLoaded ? posthog.alias.bind(posthog) : undefined,
    reset: isLoaded ? posthog.reset.bind(posthog) : undefined,
  }
}
